import React, {Component} from 'react';
import {Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ScreenEmulator from '../screen-emulator/screen-emulator';
import StageEditor from '../stage-editor/stage-editor';
import HallBoothList from './hall-booth-list';
import HallMetadata from './hall-metadata';
import HallLayout from './hall-layout';
import './hall-editor.css';
import '../common/react-tabs.css';

/** @class HallEditor
  * A component for editing a hall in a virutal expo.
  */
export default class HallEditor extends Component {
  /** @constructor
    * Creates a new instance of a HallEditor
    */
  constructor(props){
    super(props);
    this.dataURL = `/expos/${this.props.expoID}/halls/${this.props.hallID}`;
  }
  /** @function render
    * Renders the component.
    */
  render() {
    return (
      <div className="hall-editor">
        <Tabs>
          <TabList>
            <Tab>Properties</Tab>
            <Tab>Stage</Tab>
            <Tab>Booths</Tab>
            <Tab>Preview</Tab>
          </TabList>
          <TabPanel>
            <HallMetadata dataURL={this.dataURL + '/metadata'}/>
          </TabPanel>
          <TabPanel>
            <StageEditor dataURL={this.dataURL + '/stage'}/>
          </TabPanel>
          <TabPanel>
            <div className="booth-panel">
              <HallBoothList
                expoID={this.props.expoID}
                hallID={this.props.hallID}
                />
              <HallLayout
                expoID={this.props.expoID}
                hallID={this.props.hallID}
                />
            </div>
          </TabPanel>
          <TabPanel>
            <ScreenEmulator src={`/preview/#/expos/${this.props.expoID}/halls/${this.props.hallID}`} />
          </TabPanel>
        </Tabs>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/hall-editor/hall-editor.js